<template>
  <div class="app-container">
    <CrudTable entity="Ban" :columns="columns" :on-row-dbl-click="() => {}" disable-filtering />
  </div>
</template>

<script>
import CrudTable from '@/components/crud/CrudTable';
export default {
  components: {
    CrudTable
  },
  data() {
    return {
      columns: [
        'ipAddress',
        { field: 'bannedAtUtc', label: 'ban.bannedAtUtc', type: 'dateTime' },
        { field: 'bannedUntilUtc', label: 'ban.bannedUntilUtc', type: 'dateTime' }
      ]
    };
  }
};
</script>

<style scoped></style>
